import {ReactNode} from 'react';
import {HideableContent} from '../../common';
import {FindOutMoreItem} from './FindOutMoreItem';

type FindOutMoreProps = {
  visible: boolean;
  content: ReactNode;
};
export const FindOutMoreContent = ({visible, content}: FindOutMoreProps) => (
  <HideableContent visible={visible} className="py-2">
    <FindOutMoreItem title="How it works?" content={content} />
  </HideableContent>
);
